<template>
  <div>
    <v-btn color="primary" @click="open = true;"> ΚΑΤΑΘΕΣΗ ΣΕ ΤΡΑΠΕΖΑ</v-btn>
    <v-dialog max-width="800px" v-model="open">
      <v-card>
        <v-card-title> Καταθέστε το πόσο στην τράπεζα :{{ totalValue }}‎€</v-card-title>
        <v-list>
          <v-list-item>
            <v-list-item-avatar color="primary"><span style="color: white">1</span></v-list-item-avatar>
            <v-list-item-content>
              <b> Καταθέστε το αναγραφόμενο πόσο στην τράπεζα </b>
              Συνδεθείτε μέσω του e-banking σας καταθέστε το πόσο σε κάποιο από τα ακόλουθα IBAN και αποθηκεύστε την
              απόδειξη πληρωμής.
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-avatar color="primary"><span style="color: white">2</span></v-list-item-avatar>
            <v-list-item-content>
              <b> Eπισυνάψτε την απόδειξη πληρωμής </b>Eπισυνάψτε την απόδειξη πληρωμής που λάβατε από την τράπεζα σας
              στο ακόλουθο πεδίο και πατήστε το κουμπί
              "επιβεβαιώση πληρωμής".
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <v-card-title> Διαθέσιμα IBAN</v-card-title>
        <v-list v-if="userDetails.Office.Ibans">
          <v-list-item v-for="i in userDetails.Office.Ibans">
            <v-list-item-action>
              <v-icon>mdi-bank</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                {{ i }}
              </v-list-item-title>
              <v-list-item-subtitle>
                IBAN
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <v-card-text>
          <v-file-input label="Απόδειξη πληρωμής" accept=".pdf" v-model="file">
          </v-file-input>
          <v-btn color="success" :disabled="this.file === null " @click="confirm()"> ΕΠΙΒΕΒΑΙΩΣΗ ΚΑΤΑΘΕΣΗΣ</v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import PaymentMixin from "@/views/Financial/mixins/PaymentMixin";

export default {
  name: "EBankingButton",
  mixins: [PaymentMixin],
  data: () => ({
    open: false
  }),
  methods: {
    confirm() {
      this.sendPayment()
          .then(() => {
            this.open = false;
            setTimeout(() => {
              this.$emit('onApprove');
            }, 100)
          })

    }
  }

}
</script>

<style scoped>

</style>
